import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IAMNotes } from 'src/app/models/IPlan';
import { MatTableDataSource } from '@angular/material';


@Component({
  selector: 'app-plan-copy-from-previous-encounter',
  templateUrl: './plan-copy-from-previous-encounter.component.html',
  styleUrls: ['./plan-copy-from-previous-encounter.component.css']
})
export class PlanCopyFromPreviousEncounterComponent implements OnInit {

  displayedColumns: string[] = ['visitdate', 'encounterstatus', 'notes'];//, 'notes','status'
  //dataSource = ELEMENT_DATA;
  notesPopData: IAMNotes[] = [];
  dataSource = new MatTableDataSource(this.notesPopData);
  selectedelement: IAMNotes = null;
  message: string;

  constructor(
    public dialogRef: MatDialogRef<PlanCopyFromPreviousEncounterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.notesPopData = this.data.notesData;
    this.dataSource.data = this.notesPopData;
  }
  onRowClick(element) {
    if (this.selectedelement == null) {
      this.selectedelement = element;
    } else {
      this.selectedelement = null;
      this.selectedelement = element;
    }
  }
  onCopyClick() {
    if (this.selectedelement == null) {
      //alert('Please Select the notes to be added')
      this.message = "Please select the row";
    } else {
      this.dialogRef.close({
        selectednotes: this.selectedelement.prevNotes
      });
    }
  }
  onCancelClick() {
    this.dialogRef.close();
  }

}
export interface DialogData {
  notesData: IAMNotes[];
}
